import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { useAuthStore } from '@/store/auth';
import { pendingAffiliate } from '@/lib/pendingAffiliate';

export default function usePendingAffiliate() {
  const token = useAuthStore(state => state.token);
  const userId = useAuthStore(state => state.user?.id);
  const generation = useAuthStore(state => state._sessionGeneration);
  const impersonator = useAuthStore(state => state.isImpersonating);
  const isGhost = useAuthStore(state => state.user?.flags?.isGhost);
  useEffect(() => {
    if (!['ios', 'android'].includes(Platform.OS) || !token || !userId || impersonator || isGhost) return;
    const current = () => {
      const state = useAuthStore.getState();
      return !!state.token && state.user?.id === userId && state._sessionGeneration === generation && !state.isImpersonating && !state.user?.flags?.isGhost;
    };
    const claim = () => { void pendingAffiliate.claim(`${userId}:${generation}`, current); };
    claim();
    const unsubscribe = pendingAffiliate.subscribe(claim);
    const foreground = AppState.addEventListener('change', state => { if (state === 'active') claim(); });
    return () => { unsubscribe(); foreground.remove(); };
  }, [token, userId, generation, impersonator, isGhost]);
}
